import React, { useState, useEffect } from 'react'
import { useMutation } from "react-query";
import apiClient from "../../http-common";
import {
    triggerSuccess,
    triggerError,
    setErrorMessage,
    setSuccessMessage,
  } from '../Request/StatusFormatter';

const Settings = ({ onProfileUpdated }) => {
    const getStoredUser = () => {
        const stored = localStorage.getItem('delox-user');
        return stored ? JSON.parse(stored) : null;
    };

    const inviter = localStorage.getItem('invited-by');

    const initialForm = {
        name: '',
        email: '',
        phone: '',
        account_number: '',
        country: '',
        password: '',
        password_confirmation: ''
    };

    const [errors, setErrors] = useState({});
    const [profileForm, setProfileForm] = useState(initialForm);
    const [countries, setCountries] = useState(null);

    const { isLoading: isFetchingCountry, mutate: loadCountry } = useMutation(
        async () => apiClient.get(`/api/get-countries`),
        {
          onSuccess: (res) => {
            setCountries(res.data.countries);
          },
          onError: (err) => {
            setErrorMessage(err.response?.data || err);
            triggerError();
          },
        }
    );

    const onChange = (e) =>
        setProfileForm({ ...profileForm, [e.target.name]: e.target.value });

    const { isLoading: isSaving, mutate: saveProfile } = useMutation(
        async () => {
          const payload = {
            name: profileForm.name,
            email: profileForm.email,
            phone: profileForm.phone,
            account_number: profileForm.account_number,
            country: profileForm.country,
          };

          if (profileForm.password) {
            payload.password = profileForm.password;
            payload.password_confirmation = profileForm.password_confirmation;
          }

          return await apiClient.post(`/api/update-account`, payload);
        },
        {
          onSuccess: (res) => {
            setSuccessMessage(res.data);
            triggerSuccess();
            setErrors({});
            localStorage.setItem('delox-user', JSON.stringify(res.data.user));
            setProfileForm({
              ...profileForm,
              password: '',
              password_confirmation: '',
            });
            window.dispatchEvent(new Event('profileUploaded'));
            if (onProfileUpdated) {
              onProfileUpdated(res.data.user);
            }
          },
          onError: (err) => {
            const myerror = err.response?.data || err;
            setErrorMessage(myerror);
            triggerError();
            if (myerror.errors) {
                setErrors(myerror.errors);
            }
          },
        }
    );

    useEffect(() => {
        const storedUser = getStoredUser();
        if (storedUser) {
            setProfileForm({
                name: storedUser.name || '',
                email: storedUser.email || '',
                phone: storedUser.phone || '',
                account_number: storedUser.account_number || '',
                country: storedUser.country || '',
                password: '',
                password_confirmation: '',
            });
        }
        loadCountry();
    }, []);

    const fieldError = (field) => {
        if (!errors || !errors[field]) return null;
        const value = errors[field];
        return Array.isArray(value) ? value[0] : value;
    };

  return (
    <div className="container px-sm-4 px-0" style={{marginTop: '40px'}}>

    <div className="card bg-theme shadow-sm" style={{borderRadius: '10px'}}>
            <div className="d-flex mx-3 mt-3 py-1">
                <div className="align-self-center">
                    <h1 className="mb-0 text-center">PROFILE DETAILS</h1>
                </div>
            </div>
            <div className="divider divider-margins mt-3"></div>
            <div className="content mt-0">

                <div className="pb-2"></div>
                <span className='text-danger'>{fieldError('name')}</span>
                <div className="form-custom form-label form-icon">
                    <i translate="no" className="material-icons-outlined" style={{fontSize: "18px"}}>person</i>
                    <input value={profileForm.name} onChange={onChange} type="text" name="name" className="form-control bg-theme color-theme rounded-xs" id="name" placeholder="Full name"/>
                    <label htmlFor="name" className="form-label-always-active color-highlight font-11">Full Name</label>
                    <span className="font-10">(required)</span>
                </div>
                <div className="pb-2"></div>

                <div className="pb-2"></div>
                <div className="form-custom form-label form-icon">
                    <i translate="no" className="material-icons-outlined" style={{fontSize: "18px"}}>group</i>
                    <input readOnly value={(inviter !== null && inviter !== '') ? inviter : '—'} type="text" className="form-control bg-theme color-theme rounded-xs" id="inviter" placeholder="inviter"/>
                    <label htmlFor="inviter" className="form-label-always-active color-highlight font-11">Invited By</label>
                    <span className="font-10">(read only)</span>
                </div>
                <div className="pb-2"></div>

                <div className="pb-2"></div>
                <span className='text-danger'>{fieldError('account_number')}</span>
                <div className="form-custom form-label form-icon">
                    <i translate="no" className="material-icons-outlined" style={{fontSize: "18px"}}>badge</i>
                    <input value={profileForm.account_number} onChange={onChange} type="text" name="account_number" className="form-control bg-theme color-theme rounded-xs" id="account_number" placeholder="Account number"/>
                    <label htmlFor="account_number" className="form-label-always-active color-highlight font-11">Account Number</label>
                </div>
                <div className="pb-2"></div>

                <div className="pb-2"></div>
                <span className='text-danger'>{fieldError('email')}</span>
                <div className="form-custom form-label form-icon">
                    <i translate="no" className="material-icons-outlined" style={{fontSize: "18px"}}>email</i>
                    <input value={profileForm.email} onChange={onChange} type="email" name="email" className="form-control bg-theme color-theme rounded-xs" id="email" placeholder="Email address"/>
                    <label htmlFor="email" className="form-label-always-active color-highlight font-11">Email Address</label>
                    <span className="font-10">(required)</span>
                </div>
                <div className="pb-2"></div>

                <div className="pb-2"></div>
                <span className='text-danger'>{fieldError('phone')}</span>
                <div className="form-custom form-label form-icon">
                    <i translate="no" className="material-icons-outlined" style={{fontSize: "18px"}}>phone</i>
                    <input value={profileForm.phone} onChange={onChange} type="tel" name="phone" className="form-control bg-theme color-theme rounded-xs" id="phone" placeholder="Phone number"/>
                    <label htmlFor="phone" className="form-label-always-active color-highlight font-11">Phone Number</label>
                    <span className="font-10">(required)</span>
                </div>
                <div className="pb-2"></div>

                <div className="pb-2"></div>
                <span className='text-danger'>{fieldError('country')}</span>
                <div className="form-custom form-label form-icon">
                    <i translate="no" className="material-icons-outlined" style={{fontSize: "18px"}}>public</i>
                    <select value={profileForm.country} onChange={onChange} name="country" className="form-control bg-theme color-theme rounded-xs" id="country">
                        <option value="">Select country</option>
                        {countries !== null &&
                            countries.map((country) => (
                            <option key={country.name} value={country.name}>{country.name}</option>
                            ))
                        }
                    </select>
                    <label htmlFor="country" className="form-label-always-active color-highlight font-11">Country</label>
                    <span className="font-10">({isFetchingCountry ? "loading..." : "required"})</span>
                </div>
                <div className="pb-2"></div>
            </div>
        </div>

        <div className="card bg-theme shadow-sm mt-4" style={{borderRadius: '10px'}}>
            <div className="d-flex mx-3 mt-3 py-1">
                <div className="align-self-center">
                    <h1 className="mb-0 text-center">CHANGE PASSWORD</h1>
                </div>
            </div>
            <div className="divider divider-margins mt-3"></div>
            <div className="content mt-0">
                <p className="font-12 opacity-70 mb-0">Leave blank to keep your current password.</p>

                <div className="pb-2"></div>
                <span className='text-danger'>{fieldError('password')}</span>
                <div className="form-custom form-label form-icon">
                    <i translate="no" className="material-icons-outlined" style={{fontSize: "18px"}}>lock</i>
                    <input value={profileForm.password} onChange={onChange} type="password" name="password" className="form-control bg-theme color-theme rounded-xs" id="password" placeholder="New password" autoComplete="new-password"/>
                    <label htmlFor="password" className="form-label-always-active color-highlight font-11">New Password</label>
                </div>
                <div className="pb-2"></div>

                <div className="pb-2"></div>
                <span className='text-danger'>{fieldError('password_confirmation')}</span>
                <div className="form-custom form-label form-icon">
                    <i translate="no" className="material-icons-outlined" style={{fontSize: "18px"}}>lock</i>
                    <input value={profileForm.password_confirmation} onChange={onChange} type="password" name="password_confirmation" className="form-control bg-theme color-theme rounded-xs" id="password_confirmation" placeholder="Confirm password" autoComplete="new-password"/>
                    <label htmlFor="password_confirmation" className="form-label-always-active color-highlight font-11">Confirm Password</label>
                </div>
                <div className="pb-2"></div>
            </div>

            <div onClick={saveProfile} className="mx-3 mb-3 btn btn-full gradient-highlight shadow-bg shadow-bg-s">
            {isSaving ? <span>saving...</span> : <span>Save profile changes</span>}
            </div>
        </div>

    </div>
  )
}

export default Settings
